<template>
  <div class="section-title flex-row">
    <span class="section-title__text">{{ title }}</span>
    <span class="section-title__action" v-if="link" @click="goList">查看全部</span>
    <img
      v-if="link"
      class="section-title__arrow"
      referrerpolicy="no-referrer"
      src="../assets/img/icon-arrow-right.png"
      @click="goList"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
  },
  methods: {
    goList() {
      if (this.link) {
        this.$router.push(this.link)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.section-title {
  margin: 10px 7px 0 0;
  align-items: center;
  width: 100%;
  box-sizing: border-box;

  &__text {
    overflow: hidden;
    text-overflow: ellipsis;
    color: rgba(4, 100, 202, 1);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  &__action {
    overflow: hidden;
    text-overflow: ellipsis;
    color: rgba(26, 26, 26, 0.7);
    font-size: 12px;
    text-transform: uppercase;
    text-align: center;
    white-space: nowrap;
    line-height: 12px;
    margin: 0 0 0 auto;
    cursor: pointer;
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    &:active {
      transform: scale(0.9);
      opacity: 0.75;
    }
  }

  &__arrow {
    width: 4px;
    height: 7px;
    margin: 7px 0 8px 6px;
  }
}
.resetClass {
  padding: 0 16px 0 20px;
}
</style>
